<template>
  <div class="levelTable">
    <b-loading :is-full-page="false" v-model="isLoading" />
    <table class="table is-narrow is-bordered center is-fullwidth">
      <tbody>
        <tr
          v-for="i in 10"
          :key="i"
          :class="levelClass(i)"
          @click="gotoLevel(i)"
        >
          <td>Level {{ i }}</td>
          <td><MasteryLevel :level="i" /></td>
          <td style="padding: 0 0 0 0;">
            <div class="is-flex is-align-items-center">
              <PlayerWinStats
                :stats="levelStats(i)"
                style="margin-left: 5px; margin-bottom: -7px"
              />
              <div class="center">
                <img
                  v-if="levelClass(i) === 'level--current'"
                  src="@/assets/img/chess/bonus.png"
                  style="height:47px; width:47px; object-fit: cover; margin-bottom: -7px"
                />
                <img
                  v-else-if="!stats || i > stats.rating"
                  src="@/assets/img/chess/lock.png"
                  style="height:27px; object-fit: cover; margin-bottom: -7px"
                />
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import MasteryLevel from "@/components/stats/MasteryLevel.vue";
import PlayerWinStats from "@/components/stats/PlayerWinStats.vue";
import { MatchesAPI } from "@/services/api";

export default {
  components: { MasteryLevel, PlayerWinStats },

  props: ["username"],

  data() {
    return {
      stats: null,
    };
  },

  computed: {
    isLoading() {
      return this.stats == null;
    },
  },

  methods: {
    levelStats(level) {
      if (!this.stats || !this.stats.rating_statistics) return null;
      if (level > this.stats.rating_statistics.length) return null;
      return this.stats.rating_statistics[level - 1];
    },

    levelClass(level) {
      if (!this.stats) return "level--future";
      if (this.stats.rating === level) return "level--current";
      if (this.stats.rating === 0 && level === 1) return "level--current";
      if (this.stats.rating > level && level === 10) return "level--current";
      if (this.stats.rating > level) return "level--past";
      return "level--future";
    },

    gotoLevel(level) {
      if (level === 1 || level <= this.stats.rating) {
        this.$emit("onSelectLevel", level);
      }
    },
  },

  created() {
    if (!this.username) return;
    MatchesAPI.getPlayerStats(this.username).then(
      (data) => (this.stats = data)
    );
  },
};
</script>

<style scoped>
.levelTable {
  position: relative;
}

.table td {
  overflow: visible;
  vertical-align: middle;
  height: 50px;
}

.level--past {
  background-color: #674ea7;
  color: whitesmoke;
  cursor: pointer;
}

.level--current {
  background-color: #b400b4;
  color: whitesmoke;
  cursor: pointer;
}

.level--future {
  background-color: lightgray;
}
</style>
